/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNumberListRtl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M20.08 4.82V8h.942V3.698h-.666l-1.272.906v.552zm-.996 8.55V14h2.838v-.762h-1.62l.606-.666c.248-.276.445-.513.591-.71s.251-.378.315-.538.096-.32.096-.48c0-.392-.128-.694-.384-.906-.256-.212-.616-.318-1.08-.318a2.83 2.83 0 0 0-1.248.306v.804c.412-.22.78-.33 1.104-.33.46 0 .69.182.69.546 0 .088-.024.183-.072.285s-.131.226-.249.372-.283.335-.495.567zm0 6.438v-.798a2.742 2.742 0 0 0 1.188.282c.284 0 .502-.058.654-.174s.228-.282.228-.498c0-.204-.059-.362-.177-.474s-.291-.168-.519-.168a1.71 1.71 0 0 0-.612.114l-.294-.492 1.08-1.14h-1.47v-.762h2.658v.618l-1.032 1.056c.388.044.687.18.897.405s.315.51.315.85c0 .3-.068.558-.204.776s-.331.385-.585.501-.555.174-.903.174c-.228 0-.448-.023-.66-.069s-.4-.113-.564-.2zM17 5H2v2h15zm0 6H2v2h15zm0 6H2v2h15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNumberListRtl as NumberListRtl };
